import { styled } from "@mui/material/styles";

export const styles = {
  tracksContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    width: "100%",
  } as const,
  trackRoot: {
    width: "100%",
    marginBottom: "0px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "2px solid #111111",
  } as const,
  addTrack: {
    display: "flex",
    margin: "0px auto 10px 0px",
  } as const,
  addButton: {
    marginLeft: "10px",
    color: "white",
    backgroundColor: "#28B6CB",
  } as const,
  measure: {
    height: "15px",
    border: "1px solid yellow",
  } as const,
  measureContainer: {
    display: "flex",
    width: "100%",
    paddingLeft: "397px",
    color: "white",
    fontSize: "10px",
    textAlign: "center",
    marginRight: "15px",
    paddingRight: "3px",
  } as const,
};

interface RootContainerProps {
  trackCount: number;
}

export const RootContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "trackCount",
})<RootContainerProps>(({ trackCount }) => ({
  backgroundColor: "#111111",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flexStart",
  alignItems: "center",
  padding: "10px 0px",
  height: trackCount > 3 ? "100%" : "115vh",
  marginTop: "20px",
}));
